import { BellOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  Box,
  Button,
  Flex,
  Icon,
  Input,
  Select,
  Spacer,
  useDisclosure,
} from "@chakra-ui/react";
import { Space, Table } from "antd";
import axios from "axios";
import { get } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { IoAdd } from "react-icons/io5";
import { RiSearch2Line } from "react-icons/ri";
import AddNotificationsDrawer from "../drawer/AddNotificationsDrawer";
import NotificationDelete from "../modals/NotificationDelete";
import SendNotificationsModal from "../modals/SendNotificationsModal";
import styles from "./NotificationTable.module.scss";

interface Props {
  query: string;
}

const NotificationTable: React.FC<Props> = ({ query }) => {
  const searchColumns = useMemo(
    () => ["template_name", "title", "message"],
    []
  );
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [searchQuery, setSearch] = useState("");
  const [datas, setDatas] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectOptions, setSelectOptions] = useState<any>("");
  // Filter data based on search query
  const filteredData = datas.filter((item: any) => {
    const matchesSearch = searchColumns.some((column) => {
      return get(item, column, "")
        .toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
    });

    const matchesSelect = selectOptions
      ? item.notificationType.toLowerCase() === selectOptions.toLowerCase()
      : true;

    return matchesSearch && matchesSelect;
  });

  const getData = () => {
    // Fetch data from API
    setLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_BASE_URL}/admin/notification`,
    })
      .then((response) => {
        // console.log("Product Details", response.data);
        setLoading(false);
        setDatas(
          response.data.data.map((val: any, i: number) => {
            return {
              key: i + 1,
              template_name: val.template_name || "-",
              title: val.title || "-",
              notificationType: val.notificationType || "-",
              message: val.message || "-",
              image: val.image || "-",
              _id: val._id,
              value: val,
            };
          })
        );
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  const [targetData, setTargetData] = useState<any>();

  const updates = (value: any) => {
    setTargetData(value);
    onViewOpen();
  };

  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const deletes = (value: any) => {
    console.log("value", value);
    setTargetData(value);
    onDeleteOpen();
  };

  const {
    isOpen: isShowOpen,
    onOpen: onShowOpen,
    onClose: onShowClose,
  } = useDisclosure();

  const send = (value: any) => {
    setTargetData(value);
    onShowOpen();
  };

  const data = [
    {
      key: "1",
      templateImage: "/images/g1.svg",
      templateName: "Regular template 1",
      title: "New Flash offer",
      message: "book your hungry table for 50% discount",
      notificationType: "Regular",
    },
    {
      key: "2",
      templateImage: "/images/g1.svg",
      templateName: "Regular template 1",
      title: "New Flash offer",
      message: "book your hungry table for 50% discount",
      notificationType: "Regular",
    },
  ];
  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `${index + 1}`,
    },
    {
      title: "Template image",
      dataIndex: "image",
      width: 150,
      render: (image: any) => (
        <Box borderRadius="50%" overflow="hidden" w="40px" h="40px">
          <img
            src={
              `${process.env.REACT_APP_IMAGE_BASE_URL}/${image?.url}` ||
              "/images/g1.svg"
            }
            alt="Template"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
      ),
    },
    {
      title: "Template name",
      dataIndex: "template_name",
      width: 100,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 100,
    },
    {
      title: "Message",
      dataIndex: "message",
      width: 200,
    },
    {
      title: "Notification Type",
      dataIndex: "notificationType",
      width: 150,
    },
    {
      title: "Action",
      key: "value",
      width: 150,
      render: (record: any) => (
        <Space size="middle">
          <BellOutlined
            style={{ color: "#1890ff", cursor: "pointer", fontSize: "18px" }}
            onClick={() => {
              send(record);
            }}
          />
          <EditOutlined
            style={{ color: "#1890ff", cursor: "pointer", fontSize: "18px" }}
            onClick={() => {
              updates(record);
            }}
          />
          <DeleteOutlined
            style={{ color: "#ff4d4f", cursor: "pointer", fontSize: "18px" }}
            onClick={() => {
              deletes(record);
            }}
          />
        </Space>
      ),
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div className={styles.containerHeader}>
            <div>
              <Box
                display="flex"
                alignItems="center"
                bg="#FFF"
                border="1px solid #b2b2b233"
                borderRadius="12px"
                w="100%"
                maxW={"498px"}
                padding="8px"
              >
                <Box
                  pl={2}
                  display="flex"
                  alignItems="center"
                  color="#9E9E9E"
                  fontSize="2xl"
                >
                  <img
                    src="/icons/searchlogo.svg"
                    alt="searchlogo"
                    style={{ height: "24px", width: "24px" }}
                  />
                </Box>

                <Input
                  id="search"
                  type="text"
                  autoComplete="off"
                  placeholder="Search or type a command"
                  onChange={(e) => setSearch(e.target.value)}
                  fontSize="sm"
                  border="none"
                  outline="none"
                  color="#757575"
                  _focus={{
                    border: "none",
                    outline: "none",
                    boxShadow: "none",
                  }}
                  bg={"transparent"}
                  style={{
                    outline: "none",
                    boxShadow: "none",
                  }}
                />
              </Box>
            </div>

            <div className={styles.headerRight}>
              <Select
                placeholder="All Notifications"
                // w="200px"
                // w={"300px"}
                bg="white"
                border="1px solid"
                borderColor="gray.200"
                borderRadius="12px"
                value={selectOptions}
                onChange={(e) => setSelectOptions(e.target.value)}
              >
                <option value="PROMOTIONAL">Promotional</option>
                <option value="OFFER">Offer</option>
                <option value="FLASH_SALE">Flash Sale</option>
                <option value="GENERAL">General</option>
              </Select>
              <Box
                background="#E24441"
                fontSize={"sm"}
                color="#fff"
                w="300px"
                textAlign="center"
                p={3}
                cursor="pointer"
                borderRadius="8px"
                _hover={{ background: "#E24441" }}
                onClick={() => {
                  onOpen();
                }}
                // padding="14px 16px"
              >
                + Add Notification
              </Box>
            </div>
          </div>

          <Spacer></Spacer>

          <Table
            rowSelection={rowSelection}
            rowKey="key"
            columns={columns}
            dataSource={filteredData}
            scroll={{ x: "max-content" }}
            loading={loading}
            size="middle"
            style={{
              backgroundColor: "white",
              borderRadius: 6,
              // borderRadius: "16px",
            }}
            pagination={{
              position: ["bottomRight"],
              pageSize: 9,
            }}
            rowClassName={(record: any) => record.color}
          />
        </div>
      </div>
      {isOpen && (
        <AddNotificationsDrawer isOpen onClose={onClose} getData={getData} />
      )}
      {isViewOpen && targetData && (
        <AddNotificationsDrawer
          isOpen={isViewOpen}
          onClose={onViewClose}
          getData={getData}
          notification={targetData}
        />
      )}
      {isDeleteOpen && targetData && (
        <NotificationDelete
          notification={targetData}
          isOpen={isDeleteOpen}
          onClose={onDeleteClose}
          getData={getData}
        />
      )}
      {isShowOpen && (
        <SendNotificationsModal
          notification={targetData}
          isOpen={isShowOpen}
          onClose={onShowClose}
        />
      )}
    </>
  );
};

export default NotificationTable;
